import { getChainId, } from "wagmi/actions";
import { wagmiConfig as config, } from "@wagmiconfig";
import { getExplorerLink, } from "@bracket/chainography";
import type { BlockHash,  } from "@bracket/types";
import type { Notification } from "@bracket/ui";



/**
 * Creates a success notification for a successful vanity NAV update transaction
 * 
 * @param {BlockHash} hash - The transaction hash
 * @returns {Omit<Notification, "id">} A notification object without an ID
 */
export const vanityNavUpdateSuccessNotification = (
	hash: BlockHash,
): Omit<Notification, "id"> => {
	return {
		title: "Vanity NAV update successful",
		message: "you successfully updated the vanity NAV for this vault",
		type: "success",
		status: "success",
		primaryAction: {
			label: "View on explorer",
			onClick: () => {
				window.open(getExplorerLink(hash, getChainId(config)), "_blank");
			},
		},
	}
}



/**
 * Creates a failure notification for a failed vanity NAV update transaction
 * 
 * @param {Error} error - The error that occurred during the vanity NAV update
 * @returns {Omit<Notification, "id">} A notification object without an ID
 */
export const vanityNavUpdateFailedNotification = (error: Error): Omit<Notification, "id"> => {
  const message = error.message.toLowerCase();
  console.warn("Vanity NAV updated failed", message);
  return {
		title: "Vanity Nav update failed",
		message: "the Vanity NAV update for this vault failed, please try again",
		type: "error",
		status: "error",
	}
}
